export default () => {
  const items = document.querySelectorAll('.expandable');
  const pageHash = window.location.hash;

  function open(item) {
    item.querySelector('.expandable__wrapper').style.height = '0';

    setTimeout(function () {
      item.querySelector('.expandable__wrapper').style.height = item.querySelector('.expandable__content').clientHeight + 'px';
      item.classList.add('opened');
    }, 50);

    setTimeout(function () {
      item.querySelector('.expandable__wrapper').style.height = 'auto';
      item.querySelector('.expandable__content').style.position = 'static';
    }, 1000);
  }

  function close(item) {
    item.querySelector('.expandable__wrapper').style.height = item.querySelector('.expandable__content').clientHeight + 'px';

    setTimeout(function () {
      item.classList.remove('opened');
      item.querySelector('.expandable__content').style.position = 'absolute';
    }, 50);

    setTimeout(function() {
      item.querySelector('.expandable__wrapper').style.height = '0';
    }, 350);
  }

  for (const item of items) {
    const btn = item.querySelector('.expandable__btn');
    const title = item.querySelector('.expandable__title');
    const itemWrap = item.closest('.accordion__item');
    let anchor = null;

    if (itemWrap) {
      anchor = itemWrap.querySelector('.accordion__item-anchor');
    }

    const itemID = anchor ? itemWrap.querySelector('.accordion__item-anchor').getAttribute('id') : null;

    [btn, title].forEach(function(el) {
      el.addEventListener('click', function(event) {
        event.preventDefault();
        if (!item.classList.contains('opened')) {
          open(item);
        } else {
          close(item);
        }
      });
    });

    if (pageHash === '#' + itemID || pageHash === '#scroll-to-' + itemID ) {
      setTimeout(function() {
        open(item);
      }, 1500);
    }
  }
};
